import React, {Component} from 'react';
import '../../../styles/Home.css'
import RejestracjaComponent from "../../kontoComponents/RejestracjaComponent";
import Panel from "../Panel";

export default class DaneOsobowe extends Component {

    constructor(props) {
        super(props)
    }

    render() {
        return <Panel>
            <div>
                <h4 style={{textAlign: 'center', marginBottom: 8}}><b>Dane klienta</b></h4>
                <p className="small text-center"><b>ID: {JSON.parse(sessionStorage.getItem('loggedIn')).idKl} /
                    Email: {JSON.parse(sessionStorage.getItem('loggedIn')).login}</b></p>
                <RejestracjaComponent props={this.props}/>
            </div>
        </Panel>
    }

}




// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/DaneOsobowe.js